import { Injectable } from "@angular/core";

import { datesToDb, dbToDates, dbToInts, intsToDb } from "@dffedb/util";
import { DbMaalerAflaesningMedNoter, MaalerAflaesningDbMapper, MaalerAflaesningMedNoter } from "@e-forsyning/common/maaler";
import { NoteDbMapperService } from "@e-forsyning/common/note";

import { MaalerskiftDataDto } from "./model/maalerskift-data.dto";
import { MaalerskiftData } from "./model/maalerskift-data.model";
import { MaalerskiftDto } from "./model/maalerskift.dto";
import { Maalerskift } from "./model/maalerskift.model";

@Injectable({ providedIn: "root" })
export class MaalerskiftMapper {
    constructor(private readonly maalerAflaesningDbMapper: MaalerAflaesningDbMapper, private readonly noteDbMapper: NoteDbMapperService) {}

    public dtoToMaalerskiftData(data: MaalerskiftDataDto, bilagUrlTemplate: string): MaalerskiftData {
        const result: any = {
            ...data,
            maalerskift: this.dtoToMaalerskift(data.maalerskift, bilagUrlTemplate)
        };
        return result as MaalerskiftData;
    }

    public dtoToMaalerskift(data: MaalerskiftDto, bilagUrlTemplate: string): Maalerskift {
        const result: Maalerskift = {
            dato: dbToDates(data.dato),
            gammelMaaler: this.dtoToMaalerAflaesning(data.gammelMaaler, bilagUrlTemplate),
            huskelisteId: dbToInts(data.huskelisteId),
            info1: data.info1,
            info2: data.info2,
            nyMaaler: this.dtoToMaalerAflaesning(data.nyMaaler, bilagUrlTemplate)
        };
        return result;
    }

    public maalerskiftDataToDto(data: MaalerskiftData): MaalerskiftDataDto {
        const result: MaalerskiftDataDto = {
            ...data,
            maalerskift: this.maalerskiftToDto(data.maalerskift)
        };
        return result;
    }

    public maalerskiftToDto(data: Maalerskift): MaalerskiftDto {
        const result: MaalerskiftDto = {
            dato: datesToDb(data.dato),
            gammelMaaler: this.maalerAflaesningToDto(data.gammelMaaler),
            huskelisteId: intsToDb(data.huskelisteId),
            info1: data.info1,
            info2: data.info2,
            nyMaaler: this.maalerAflaesningToDto(data.nyMaaler)
        };
        return result;
    }

    private dtoToMaalerAflaesning(data: DbMaalerAflaesningMedNoter, bilagUrlTemplate: string): MaalerAflaesningMedNoter {
        const maalerAflaesning = this.maalerAflaesningDbMapper.dbToMaalerAflaesning(data);
        const noter = this.noteDbMapper.dbToNoter(data.noter, bilagUrlTemplate);
        const result = {
            ...maalerAflaesning,
            noter
        };
        return result;
    }

    private maalerAflaesningToDto(data: MaalerAflaesningMedNoter): DbMaalerAflaesningMedNoter {
        const aflaesning = this.maalerAflaesningDbMapper.maalerAflaesningToDb(data);
        const noter = this.noteDbMapper.noterToDb(data.noter);
        const result: DbMaalerAflaesningMedNoter = {
            ...aflaesning,
            noter
        };
        return result;
    }
}
